import { Zap, Target, Shield, Users } from 'lucide-react';

/* ROLES stores translation keys — labels resolved at render time via useTranslation() */
export const ROLES = [
  { value: 'cto', labelKey: 'smb.form.roleCTO' },
  { value: 'it_manager', labelKey: 'smb.form.roleIT' },
  { value: 'ops_leader', labelKey: 'smb.form.roleOps' },
  { value: 'consultant', labelKey: 'smb.form.roleConsultant' },
  { value: 'other', labelKey: 'smb.form.roleOther' },
];

export const VALUE_PROPS = [
  { icon: Zap, key: 'speed' },
  { icon: Target, key: 'specialization' },
  { icon: Shield, key: 'certainty' },
  { icon: Users, key: 'accessibility' },
];
